import React, { memo, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PreLoader from '../PreLoader';
import ApiService from "../../services/ApiService";
import moment from "moment";

function WithdrawalHistory() {
    const { userData } = useSelector((state) => state.auth);
    const [Loader, setLoader] = useState(false);
    const [Items, setItems] = useState([]);

    const getList = useCallback(async () => {
        setLoader(true);
        try {
            const response = await new ApiService().GET(`/user-withdrawal-history?user_id=${userData.id}`);
            console.log("user-withdrawal-history response:", response.data);
            if (response.data && response.data.status === "1" && response.data.data) {
                setItems(response.data.data);
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error("Error fetching withdrawal history:", error);
            setItems([]);
        } finally {
            setLoader(false);
        }
    }, [userData.id]);

    useEffect(() => {
        getList();
    }, [getList]);

    const getStatusInfo = (status) => {
        const normalized = String(status).toLowerCase();
        if (normalized === '1' || normalized === 'success') {
            return { label: 'SUCCESS', color: '#8ABB45' };
        } else if (normalized === '0' || normalized === 'pending') {
            return { label: 'PENDING', color: '#ffc107' };
        } else {
            return { label: 'FAILED', color: '#dc3545' };
        }
    };

    return (
        <>
            <PreLoader Loader={Loader} />

            <div className="add-fund">
                <h2>Withdrawal History</h2>
                <p>Track your payouts and pending requests</p>
            </div>

            <div className="connections mt-3">
                {Items.map((item, index) => {
                    const statusInfo = getStatusInfo(item.status);
                    return (
                        <div className="profile wallet-de" key={item.id || index} style={{ borderLeft: `4px solid ${statusInfo.color}` }}>
                            <div className="details wallet-de-des" style={{ cursor: "auto" }}>
                                <h2>Withdrawal Request #{item.id}</h2>
                                <p className="opacity-75">
                                    Date: {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm") : 'N/A'}
                                </p>
                            </div>
                            <div className="wallet-de-card text-end">
                                <h3 className="fw-bold mb-1" style={{ color: "#000" }}>
                                    ${Number(item.amount).toFixed(2)}
                                </h3>
                                <span className="badge p-2 fw-bold" style={{ backgroundColor: `${statusInfo.color}33`, color: statusInfo.color, borderRadius: "6px", fontSize: "0.85rem" }}>
                                    {statusInfo.label}
                                </span>
                            </div>
                        </div>
                    );
                })}

                {Items.length === 0 && !Loader && (
                    <div className="profile text-center py-5">
                        <div className="details w-100">
                            <h2 className="opacity-50">No Withdrawal Records Found!</h2>
                            <p className="opacity-40">Your withdrawal requests will appear here once submitted.</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default memo(WithdrawalHistory);
